import React from "react";
import "./IntakeForm.css";
import useWindowDimensions from "../../components/getWindowDimensions";

function IntakeForm() {
  const { width } = useWindowDimensions();

  return (
    <div className="intake-form-container">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScR_BDZcyu2GySoqe_DmECBPs6yxG6YRyfYk18nabSM2WPuSQ/viewform?embedded=true"
        width={width < 1060 ? "100%" : "640"}
        height="2775"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
}

export default IntakeForm;
